import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client/react/hooks';
import { gql } from '@yi/core';

import { notifyBugsnag } from '~/common';

export const useMyLive = (opts?: { lazy?: boolean }) => {
  const [myLiveQuery, { loading, data }] = useLazyQuery<
    gql.typesClient.Query_AllCurrentUserLiveRegistrations,
    {}
  >(gql.Query_AllCurrentUserLiveRegistrations, {
    fetchPolicy: 'cache-and-network',
    onError: error => {
      notifyBugsnag(error);
    },
  });

  const myLive_ =
    data?.AllCurrentUserLiveRegistrations &&
    'currentUserLiveRegistrations' in data?.AllCurrentUserLiveRegistrations
      ? data?.AllCurrentUserLiveRegistrations.currentUserLiveRegistrations
      : [];

  const myLive = [...myLive_].sort((firstItem, secondItem) => {
    const isUpcomingFirstItem =
      new Date(parseInt(firstItem.content.start_date.timestamp, 10)) > new Date();
    const isUpcomingSecondItem =
      new Date(parseInt(secondItem.content.start_date.timestamp, 10)) > new Date();
    if (isUpcomingFirstItem && isUpcomingSecondItem) {
      return (
        new Date(firstItem.content.start_date.iso8601).getTime() -
        new Date(secondItem.content.start_date.iso8601).getTime()
      );
    } else {
      return -1;
    }
  });

  useEffect(() => {
    if (!opts?.lazy) myLiveQuery();
  }, [opts?.lazy, myLiveQuery]);

  return { myLive, loading, myLiveQuery };
};
